module.exports = __webpack_public_path__ + "img/telematik_s.4f5feb84.svg";